<template>
  <div class="hotSaleBox">
    <div
      id="root"
      class="root"
    >
      <h3>往期学员评价</h3>
      <swiper
        :options="swiperOption"
        ref="mySwiper"
        class="myHot-swipe"
      >

        <swiper-slide
          :id="{ id: index }"
          v-for="(item, index) in hotList"
          :key="index"
        >
          <div class="hotSaleCardBox">
            <div class="cardBg"></div>
            <div class="hotSaleCenter">
              <div class="cardPhoto">
                <img
                  :src="item.avatar || require('../../../assets/img/personalImg/defaultAvatar.png')"
                  alt=""
                >
              </div>
              <div class="cardIntroduce">
                <h2>{{item.userName}}</h2>
                <span>{{item.evaluationContent}}</span>
              </div>
            </div>

          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { swiper, swiperSlide } from 'vue-awesome-swiper';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/dist/css/swiper.css';

export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    hotList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperOption: {
        direction: 'horizontal',
        // loop: true,
        initialSlide: 0,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 'auto',
        preventLinksPropagation: false,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper

      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
  },
  watch: {

  },

  mounted() {
  },

  methods: {

  },
  destroyed() {
  },
};
</script>

<style lang="scss" scoped>
.hotSaleBox {
  width: 100%;
  overflow: hidden;
  .root {
    h3 {
      font-size: 32px;
      font-weight: 500;
      color: #111111;
      line-height: 44px;
      margin-bottom: 32px;
      margin-left: 40px;
    }
    .myHot-swipe {
      box-sizing: border-box;
      width: 100%;
      height: 206px;
      .hotSaleCardBox {
        width: 650px;
        height: 100%;
        background: #fff;
        border-radius: 16px;
        pointer-events: none;
        .cardBg {
          width: 100%;
          height: 96px;
          background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/hotSaleCard.png)
            no-repeat;
          background-size: 100% 100%;
        }
        .hotSaleCenter {
          box-sizing: border-box;
          width: 100%;
          padding: 32px 10px 32px 24px;
          display: flex;
          align-items: flex-start;
          margin-top: -106px;
          .cardPhoto {
            img {
              width: 64px;
              height: 64px;
              border-radius: 50%;
              margin-right: 32px;
            }
          }
          .cardIntroduce {
            h2 {
              width: 526px;
              font-size: 28px;
              font-weight: 500;
              color: #333;
              line-height: 40px;
              margin-bottom: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            span {
              font-size: 28px;
              font-weight: 400;
              color: #333333;
              line-height: 40px;
              display: inline-block;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;

              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
          }
        }
      }
    }
  }

  .swiper-container .swiper-wrapper {
    width: 100%;
  }
  .swiper-container .swiper-wrapper .swiper-slide {
    width: 86%;
    margin: 0 7%;
  }
  .swiper-container .swiper-wrapper .swiper-slide-prev {
    height: 180px;
    margin-top: 12px;
    right: -10%;
  }
  .swiper-container .swiper-wrapper .swiper-slide-next {
    margin-top: 12px;
    height: 180px;
    left: -10%;
  }
}
</style>
